/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmDuplicateCandidateEntity
 */
export interface MdmDuplicateCandidateEntity {
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateEntity
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateEntity
     */
    entityId1?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateEntity
     */
    entityId2?: string;
    /**
     * 
     * @type {number}
     * @memberof MdmDuplicateCandidateEntity
     */
    confidenceScore?: number;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateEntity
     */
    matchedRules?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateEntity
     */
    matchDetails?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateEntity
     */
    status?: MdmDuplicateCandidateEntityStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof MdmDuplicateCandidateEntity
     */
    detectedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MdmDuplicateCandidateEntity
     */
    reviewedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateEntity
     */
    reviewedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateEntity
     */
    reviewNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateEntity
     */
    mergedRecordId?: string;
    /**
     * 
     * @type {Date}
     * @memberof MdmDuplicateCandidateEntity
     */
    createdAt?: Date;
}


/**
 * @export
 */
export const MdmDuplicateCandidateEntityStatusEnum = {
    Pending: 'PENDING',
    Merged: 'MERGED',
    NotDuplicate: 'NOT_DUPLICATE',
    ManualReview: 'MANUAL_REVIEW',
    AutoMerged: 'AUTO_MERGED'
} as const;
export type MdmDuplicateCandidateEntityStatusEnum = typeof MdmDuplicateCandidateEntityStatusEnum[keyof typeof MdmDuplicateCandidateEntityStatusEnum];


/**
 * Check if a given object implements the MdmDuplicateCandidateEntity interface.
 */
export function instanceOfMdmDuplicateCandidateEntity(value: object): value is MdmDuplicateCandidateEntity {
    return true;
}

export function MdmDuplicateCandidateEntityFromJSON(json: any): MdmDuplicateCandidateEntity {
    return MdmDuplicateCandidateEntityFromJSONTyped(json, false);
}

export function MdmDuplicateCandidateEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmDuplicateCandidateEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId1': json['entityId1'] == null ? undefined : json['entityId1'],
        'entityId2': json['entityId2'] == null ? undefined : json['entityId2'],
        'confidenceScore': json['confidenceScore'] == null ? undefined : json['confidenceScore'],
        'matchedRules': json['matchedRules'] == null ? undefined : json['matchedRules'],
        'matchDetails': json['matchDetails'] == null ? undefined : json['matchDetails'],
        'status': json['status'] == null ? undefined : json['status'],
        'detectedAt': json['detectedAt'] == null ? undefined : (new Date(json['detectedAt'])),
        'reviewedAt': json['reviewedAt'] == null ? undefined : (new Date(json['reviewedAt'])),
        'reviewedBy': json['reviewedBy'] == null ? undefined : json['reviewedBy'],
        'reviewNotes': json['reviewNotes'] == null ? undefined : json['reviewNotes'],
        'mergedRecordId': json['mergedRecordId'] == null ? undefined : json['mergedRecordId'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function MdmDuplicateCandidateEntityToJSON(json: any): MdmDuplicateCandidateEntity {
    return MdmDuplicateCandidateEntityToJSONTyped(json, false);
}

export function MdmDuplicateCandidateEntityToJSONTyped(value?: MdmDuplicateCandidateEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'entityType': value['entityType'],
        'entityId1': value['entityId1'],
        'entityId2': value['entityId2'],
        'confidenceScore': value['confidenceScore'],
        'matchedRules': value['matchedRules'],
        'matchDetails': value['matchDetails'],
        'status': value['status'],
        'detectedAt': value['detectedAt'] == null ? undefined : ((value['detectedAt']).toISOString()),
        'reviewedAt': value['reviewedAt'] == null ? undefined : ((value['reviewedAt']).toISOString()),
        'reviewedBy': value['reviewedBy'],
        'reviewNotes': value['reviewNotes'],
        'mergedRecordId': value['mergedRecordId'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

